export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToProcess = () => {
    const element = document.getElementById('proceso');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Imagen de fondo */}
      <img 
        src="https://static.readdy.ai/image/33540390f643937a387ee69ee6db3814/853d40fd8177c42be308305a81d3356c.jpeg"
        alt="Cirujano veterinario Almería especializado en TPLO, traumatología y cirugía veterinaria avanzada"
        title="Cirugía veterinaria especializada Almería - Dr. Pablo Conejero"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      
      {/* Overlay oscuro */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary-800/90 via-primary-700/80 to-secondary-600/70"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center lg:text-left lg:max-w-2xl">
          <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-display font-bold text-white mb-4 lg:mb-6 leading-tight">
            Pablo Conejero
            <span className="block text-accent-400">Cirugía Veterinaria</span>
            <span className="block text-accent-400">Especializada</span>
          </h1>
          
          <p className="text-base md:text-lg text-gray-100 mb-6 lg:mb-8 leading-relaxed">
            Servicio móvil de traumatología y ortopedia veterinaria (TPLO, fracturas, luxaciones), oncología, neurocirugía, cirugía avanzada torácica y abdominal para clínicas en Almería y provincias limítrofes. Precisión técnica, acompañamiento humano y equipamiento de última generación.
          </p>

          <div className="grid grid-cols-3 gap-3 lg:gap-4 mb-6 lg:mb-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 lg:p-4 text-center">
              <div className="text-xl lg:text-2xl font-bold text-accent-400">25+</div>
              <div className="text-xs lg:text-sm text-gray-200">Años Experiencia</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 lg:p-4 text-center">
              <div className="text-xl lg:text-2xl font-bold text-accent-400">24h</div>
              <div className="text-xs lg:text-sm text-gray-200">Respuesta</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 lg:p-4 text-center">
              <div className="text-xl lg:text-2xl font-bold text-accent-400">+23</div>
              <div className="text-xs lg:text-sm text-gray-200">Centros Colaboradores</div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 lg:gap-4 justify-center lg:justify-start">
            <button
              onClick={scrollToProcess}
              className="border-2 border-white text-white hover:bg-white hover:text-primary-800 px-6 lg:px-8 py-3 lg:py-4 rounded-lg font-semibold text-base lg:text-lg transition-all duration-300 whitespace-nowrap text-center"
            >
              <i className="ri-settings-3-line mr-2"></i>
              Cómo Funciona
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}